import { font18Bold, fontLabelBold, pickDivergingMain } from '@/materials'
import styled from '@emotion/styled'
import * as React from 'react'
import { useBallotContext } from '../../contexts'
import { TiebreakLabelText } from '../tiebreak-label-text'

const TieBreakTag = styled('div')<{ small?: boolean }>`
  ${({ small }) => (small ? font18Bold : fontLabelBold)};
`

export const TieBreakRow = ({ small = false }: { small?: boolean }) => {
  const { ballotVariant } = useBallotContext()

  if (ballotVariant !== 'tieBreak') {
    return null
  } else {
    const [yea, nay] = pickDivergingMain('tieBreak')

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
        <TieBreakTag small={small} style={{ color: yea }}>
          <TiebreakLabelText outcome="yea" />
        </TieBreakTag>
        <TieBreakTag small={small} style={{ color: nay }}>
          <TiebreakLabelText outcome="nay" />
        </TieBreakTag>
      </div>
    )
  }
}
